import React from "react";

class ButtonOptions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedDays: [],
    };
  }

  handleClick = (e) => {
    e.preventDefault();

    let buttonId = e.target.id;
    let buttonSelected = document.getElementById(buttonId);

    buttonSelected.classList.toggle("colorSeleccion");

    let dayString = ` ${e.target.name}: ${e.target.textContent}`;
    let dayIndex = this.state.selectedDays.indexOf(dayString);

    if (dayIndex === -1) {
      this.state.selectedDays.push(dayString);
    } else {
      this.state.selectedDays.splice(dayIndex, 1);
    }
  };

  getSelectedDays() {
    return this.state.selectedDays;
  }

  render() {
    const { hora1, hora2, hora3, day, id } = this.props;
    return (
      <React.Fragment>
        <div>
          <p className="text-center Psize">{day}</p>
          <div className="row justify-content-around mb-3">
            <button
              name={day}
              id={`${id}1`}
              onClick={this.handleClick}
              className="btn btn-dark"
            >
              {hora1}
            </button>
            <button
              name={day}
              id={`${id}2`}
              onClick={this.handleClick}
              className="btn btn-dark"
            >
              {hora2}
            </button>
            <button
              name={day}
              id={`${id}3`}
              onClick={this.handleClick}
              className="btn btn-dark"
            >
              {hora3}
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default ButtonOptions;
